import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
// import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
// import { IconBoxReusableSeatingComponent } from "../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";
// import PendingDashboard from "./pendingDashboard/PendingDashboard";
import ReservationDashboard from "./reservationDashboard/ReservationDashboard";
import Media from "react-media";

export class MainReservation extends Component {
  render() {
    try{
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>
            <div className="right-side-panel">
            <RightSideNavigation displayButton="addDiner" />
              <Container fluid className="p-0">
                <ReservationDashboard   pathname={this.props.location.pathname}   />
              </Container>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
  catch(e){
    console.log(e);
  }
  }
}
export default MainReservation;
